<template>
  <div v-if="$buttonAuthority(allButton, 'list')">
    <div class="search-class">
      <el-form
        :model="searchTxt"
        :inline="true"
        size="small"
        class="serarch-form"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="平台账号">
          <el-select
            v-model="searchTxt.account"
            clearable
            filterable
            placeholder="请选择"
            class="input-width"
          >
            <el-option
              v-for="(val, key, i) in ebayAccountList"
              :label="val"
              :value="val"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客服人员">
          <el-select
            v-model="searchTxt.userId"
            clearable
            filterable
            placeholder="请选择"
            class="input-width"
          >
            <el-option
              v-for="(val, key, i) in dropList.ebayCustomerList"
              :label="val"
              :value="key"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="评论类型">
          <el-select
            v-model="searchTxt.commentType"
            clearable
            multiple
            collapse-tags
            placeholder="请选择"
            class="input-width"
          >
            <el-option
              v-for="(val, key, i) in dropList.CommentType"
              :label="val"
              :value="val"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="差评原因">
          <el-select
            v-model="searchTxt.lameReason"
            clearable
            placeholder="请选择"
            class="input-width"
          >
            <el-option
              v-for="(val, key, i) in renderList.lameReason"
              :label="val"
              :value="key"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div style="display: flex">
            <el-select
              v-model="inputKey"
              placeholder="请选择"
              class="width110"
              @change="setInput"
            >
              <el-option
                v-for="(val, i) in inputTxt"
                :label="val.name"
                :value="val.key"
                :key="i"
              ></el-option>
            </el-select>
            <el-input
              class="input-width"
              clearable
              v-model.trim="numberTxt"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="评论时间">
          <el-date-picker
            v-model="searchTxt.commentBeginTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
            class="input-width"
          >
          </el-date-picker>
          -
          <el-date-picker
            v-model="searchTxt.commentEndTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
            class="input-width"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search()" icon="el-icon-search"
            >查找</el-button
          >
          <el-button @click="reset()" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="main-table">
      <div class="table-header">
        <exportComment
          v-if="$buttonAuthority(allButton, 'export')"
          :url="'/crm/yyEbayComment/exportCsv'"
          :param="exportObj"
          :fileName="'eBay中差评列表_'"
          :requestType="'post'"
        ></exportComment>
        <el-button
          type="warning"
          @click="updateReason"
          v-if="$buttonAuthority(allButton, 'updateReason')"
          >差评维护</el-button
        >
      </div>
      <commonTable
        ref="multipleTable"
        type="selection"
        :isExpand="false"
        :loading="loading"
        :tableData="tableData"
        :tableLabel="tableLabel"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="pagination.pageSize"
        :currentPage="pagination.page"
        :total="pagination.total"
        :tableOption="tableOption"
        @handleButton="handleButton"
        @handleSelectionChange="handleSelectionChange"
      ></commonTable>
    </div>
    <add-remark
      v-if="isAdd"
      @isShowEdit="isShowEdit"
      :scope="scope"
      @getList="getList"
      :platform="platform"
    >
    </add-remark>
    <orderInfo
      v-if="isDetail"
      @isShowEdit="isShowEdit"
      :scope="scope"
      :platform="platform"
    ></orderInfo>
    <editReason
      v-if="isUpdate"
      :platform="platform"
      :renderList="renderList"
      :dataList="dataList"
      @getList="getList"
      @isShowEdit="isShowEdit"
    >
    </editReason>
  </div>
</template>
<script>
/**
 * eBay 中差评列表页
 * 功能：支持平台账号/客服/评论类型多选/差评原因/单号/评论时间筛选、导出 CSV、差评维护、增加备注、订单详情、跳转 eBay 发送邮件页面。
 */
import { geteBayFeeBackList } from "@/api/user";
import addRemark from "../components/addRemark.vue";
import orderInfo from "../components/orderInfo.vue";
import editReason from "../components/updateReason.vue";
export default {
  components: {
    addRemark,
    orderInfo,
    editReason,
  },
  data() {
    return {
      platform: 2, // ebay平台id
      // 是否显示新增备注弹窗
      isAdd: false,
      // 是否显示订单详情弹窗
      isDetail: false,
      // 是否显示差评原因维护弹窗
      isUpdate: false,
      // 页面按钮权限列表
      allButton: [],
      // 表格加载状态
      loading: true,
      // 是否首次加载（首次用于初始化列配置）
      isFirst: true,
      // 选中的行数据（传给弹窗组件）
      scope: {},
      // 表格数据（初始占位数据，疑似复制残留）
      tableData: [{ userName: "传统美德" }],
      // 表格列配置
      tableLabel: [],
      // 后端返回的表头映射
      titleMap: [],
      // 后端返回的渲染列表数据
      renderList: {},
      // 下拉数据（初始为数组但按对象使用，与后端约定不符）
      dropList: [],
      // 单号查询
      inputKey: "orderId",
      numberTxt: "",
      inputTxt: [
        { name: "订单编号", key: "orderId" },
        { name: "平台订单号", key: "platformId" },
        { name: "itemID", key: "itemId" },
        { name: "买家ID", key: "transactionId" },
      ],
      // 表格勾选的行数据（用于差评维护/导出）
      dataList: [],
      // 导出 CSV 参数（勾选行的 id 列表）
      exportObj: {
        query: {
          idList: [],
        },
      },
      // 搜索条件
      searchTxt: {
        account: "",
        commentType: "",
        feedbackRatingStar: "",
        orderId: "",
        platformId: "",
        itemId: "",
        transactionId: "",
        userId: "",
        commentBeginTime: "",
        commentEndTime: "",
        lameReason: "",
      },
      // 分页参数
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      // 表格操作列配置（增加备注/订单详情/发送邮件）
      tableOption: {
        label: "操作",
        width: "150",
        fixed: "right",
        options: [
          {
            label: "增加备注",
            type: "text",
            methods: "remark",
            size: "mini",
          },
          {
            label: "订单详情",
            type: "text",
            methods: "detail",
            size: "mini",
          },
          {
            label: "发送邮件",
            type: "text",
            methods: "send",
            size: "mini",
          },
        ],
      },
    };
  },
  computed: {
    ebayAccountList: {
      get() {
        return this.$store.getters.dropList.ebayAccountList;
      },
    },
  },
  activated() {
    // "customerList",
    this.$store.dispatch("getDropListTwo", ["ebayAccountList"]);
  },
  /** 初始化按钮权限、操作列权限并加载中差评列表 */
  created() {
    this.allButton = this.$getStorage(this.$route.name + "_button");
    if (this.$buttonAuthority(this.allButton, "list")) {
      this.tableOptionAuth();
      this.getList();
    }
  },
  methods: {
    /** 根据后端 titleMap 生成表格列配置，并替换单号信息/SKU 信息/评论详情列、删除多余列 */
    getTableLabel() {
      let order = {
        label: "单号信息",
        param: "orderId",
        align: "left",
        width: "190",
        show: true,
        render: (h, param) => {
          let orderId = h("p", "订单编号：" + param.row.orderId);
          let plateform = h("p", "平台订单号：" + param.row.platformId);
          return h("div", null, [orderId, plateform]);
        },
      };
      let sku = {
        label: "SKU信息",
        param: "orderId",
        align: "left",
        width: "200",
        show: true,
        render: (h, param) => {
          let sku = h("p", "SKU：" + param.row.sku);
          let itemID = h("p", "itemID：" + param.row.itemId);
          let name = h("p", "产品中文名：" + param.row.skuName);

          return h("div", null, [sku, itemID, name]);
        },
      };
      let comments = {
        label: "评论详情",
        param: "commentText",
        align: "left",
        width: "280px",
        show: true,
        isShowTooltip: false,
        // render: (h, param) => {
        //   let text = h(
        //     "p",
        //     {
        //       style: {
        //         "word-wrap": "break-word",
        //       },
        //     },
        //     param.row.commentText
        //   );
        //   return [text];
        // },
      };
      this.tableLabel = this.$getTableLabel(this.titleMap, this.renderList);
      this.tableLabel.splice(0, 3, order);
      this.tableLabel.splice(1, 3, sku);
      this.tableLabel.splice(8, 3);
      this.tableLabel.splice(6, 1, comments);
      this.loading = false;
    },
    /** 查询中差评列表 */
    getList() {
      this.loading = true;
      geteBayFeeBackList(this.pagination).then((result) => {
        if (result.code == 200) {
          this.tableData = result.data.pageInfo.records;
          this.pagination.total = result.data.pageInfo.total;
          let label = result.data.renderList;
          this.dropList = result.data.dropList;
          if (label == null) {
            this.renderList = {};
          } else {
            Object.assign(this.renderList, label);
          }
          if (this.isFirst) {
            this.titleMap = result.data.titleMap;
            this.getTableLabel();
          } else {
            this.loading = false;
          }
          this.$refs.multipleTable.clear();
        }
      });
    },
    /** 切换查询字段时清空之前的单号查询条件（注意：清除列表中的 transactionId 键名拼写有误，实际清空失效） */
    setInput(val) {
      this.$delectObj(this.pagination, [
        "orderId",
        "platformId",
        "itemId",
        "ortransactionIdderId",
      ]);
      this.numberTxt = "";
    },
    /** 差评维护：校验已勾选数据后打开差评原因维护弹窗 */
    updateReason() {
      if (this.dataList.length <= 0) {
        return this.$message.warning("请选择需要操作的数据项！");
      } else {
        this.isUpdate = true;
      }
    },
    /** 按当前输入条件查询中差评列表（评论类型多选以逗号拼接提交） */
    search() {
      this.searchTxt[this.inputKey] = this.numberTxt;
      this.pagination.page = 1;
      Object.assign(this.pagination, this.searchTxt);
      this.pagination.commentType =
        this.searchTxt.commentType != ""
          ? this.searchTxt.commentType.join(",")
          : "";
      this.exportObj.query.idList = [];
      Object.assign(this.exportObj.query, this.searchTxt);
      this.isFirst = false;
      this.getList();
    },
    /** 重置查询条件并重新加载列表 */
    reset() {
      this.$delectObj(this.searchTxt);
      this.$delectObj(this.pagination, [
        "account",
        "feedbackRatingStar",
        "commentType",
        "orderId",
        "platformId",
        "itemId",
        "transactionId",
        "userId",
        "commentBeginTime",
        "commentEndTime",
        "lameReason",
      ]);
      this.pagination.page = 1;
      this.pagination.pageSize = 10;
      this.isFirst = false;
      Object.assign(this.exportObj.query, this.searchTxt);
      this.numberTxt = "";
      this.inputKey = "orderId";
      this.getList();
    },
    /** 表格操作列按钮分发：增加备注/订单详情/发送邮件
     * @param {Object} data 操作信息（methods 为按钮标识，row 为行数据）
     */
    handleButton(data) {
      var funType = data.methods;
      if (funType === "remark") {
        this.addClick(data.row);
      } else if (funType === "detail") {
        this.seeDetail(data.row);
      } else if (funType === "send") {
        this.toSend(data.row);
      }
    },
    /** 跳转至 eBay 发送邮件页面
     * @param {Object} row 选中的评论行数据
     */
    toSend(row) {
      // 跳转至eBay发送邮件页面
      // 路由跳转参数：收件人（买家ID）、订单号、标题（itemID）
      let query = {
        orderNo: row.orderId,
        recipients: row.commentingUser,
        title: row.itemId,
        type: "send",
      };
      this.$router.push({
        name: "senEmail",
        query: query,
      });
    },
    /** 打开新增备注弹窗
     * @param {Object} row 选中的评论行数据
     */
    addClick(row) {
      this.isAdd = true;
      this.scope = row;
    },
    /** 打开订单详情弹窗
     * @param {Object} row 选中的评论行数据
     */
    seeDetail(row) {
      this.scope = row;
      this.isDetail = true;
    },
    /** 关闭所有弹窗并清空选中数据 */
    isShowEdit() {
      this.isAdd = false;
      this.isDetail = false;
      this.isUpdate = false;
      this.scope = {};
    },
    /** 每页条数变化时重新查询
     * @param {Number} value 每页条数
     */
    handleSizeChange(value) {
      this.pagination.pageSize = value;
      this.pagination.page = 1;
      this.getList();
    },
    /** 页码变化时重新查询
     * @param {Number} value 当前页码
     */
    handleCurrentChange(value) {
      this.pagination.page = value;
      this.getList();
    },
    /** 表格勾选变化，更新差评维护数据与导出的 id 列表
     * @param {Array} value 勾选的行数据
     */
    handleSelectionChange(value) {
      this.dataList = value;
      this.exportObj.query.idList = value.map((item) => item.id);
    },
    /** 按按钮权限过滤表格操作列 */
    tableOptionAuth() {
      let array = this.tableOption.options;
      let authOption = [];
      array.forEach((element) => {
        if (this.$buttonAuthority(this.allButton, element.methods)) {
          authOption.push(element);
        }
      });
      if (authOption.length > 0) {
        this.tableOption.options = authOption;
      } else {
        this.tableOption = {};
      }
    },
  },
};
</script>
<style lang="scss">
.width110 {
  width: 110px !important;
  margin-right: 10px;
}
</style>